import { TemperatureUnit } from "./temperatureUnit.code";
import { WindSpeedUnit } from "./windSpeedUnit.code";
import { DistanceUnit } from "./distanceUnit.code";

export class UnitDto {
    public accountSeq!: number;
    public windSpeedUnit!: number;
    public temperatureUnit!: number;
    public distanceUnit!: number;
    
    public windSpeedCode!: WindSpeedUnit;
    public temperatureCode!: TemperatureUnit;
    public distanceCode!: DistanceUnit;

    public setCodes(): void {
        switch (this.windSpeedUnit) {
            case 0: 
                this.windSpeedCode = WindSpeedUnit.MPH;
                break;
            case 1: 
                this.windSpeedCode = WindSpeedUnit.KMH;
                break;
            case 2: 
                this.windSpeedCode = WindSpeedUnit.KNOTS;
                break;
            case 3: 
                this.windSpeedCode = WindSpeedUnit.MPS;
                break;
            case 4: 
                this.windSpeedCode = WindSpeedUnit.BFT;
                break;
        }

        switch (this.temperatureUnit) {
            case 0: 
                this.temperatureCode = TemperatureUnit.C;
                break;
            case 1: 
                this.temperatureCode = TemperatureUnit.F;
                break;
        }

        switch (this.distanceUnit) {
            case 0: 
                this.distanceCode = DistanceUnit.KM;
                break;
            case 1: 
                this.distanceCode = DistanceUnit.MILE;
                break;
        }
    }

    public convertWindSpeedUnitText(): string {
        switch (this.windSpeedCode) {
            case WindSpeedUnit.MPH: 
                return "mile/h";
            case WindSpeedUnit.KMH: 
                return "km/h";
            case WindSpeedUnit.KNOTS: 
                return "knots";
            case WindSpeedUnit.MPS: 
                return "m/s";
            case WindSpeedUnit.BFT: 
                return "bft";
        }
    }

    public convertTemperatureUnitText(): string {
        switch (this.temperatureCode) {
            case TemperatureUnit.C: 
                return "℃";
            case TemperatureUnit.F: 
                return "℉";
        }
    }

    public convertDistanceUnitText(): string {
        switch (this.distanceCode) {
            case DistanceUnit.KM: 
                return "km";
            case DistanceUnit.MILE: 
                return "mile";
        }
    }

    public convertCalculatedWindSpeed(windSpeedMeter: number): number {
        switch (this.windSpeedCode) {
            case WindSpeedUnit.MPH: 
                return parseFloat((windSpeedMeter * 2.237).toFixed(1));
            case WindSpeedUnit.KMH: 
                return parseFloat((windSpeedMeter * 3.6).toFixed(1));
            case WindSpeedUnit.KNOTS: 
                return parseFloat((windSpeedMeter * 1.944).toFixed(1));
            case WindSpeedUnit.MPS: 
                return parseFloat((windSpeedMeter * 1).toFixed(1));
            case WindSpeedUnit.BFT: 
                return parseFloat((windSpeedMeter * 1.126).toFixed(1));
        }
    }

    public convertCalculatedTemperature(temperatureC: number): number {
        switch (this.temperatureCode) {
            case TemperatureUnit.C: 
                return parseFloat(temperatureC.toFixed(1));
            case TemperatureUnit.F: 
                return parseFloat(((temperatureC * 9 / 5) + 32).toFixed(1));
        }
    }

    public convertCalculatedDistance(distanceM: number): number {
        switch (this.distanceCode) {
            case DistanceUnit.KM: 
                return parseFloat((distanceM / 1000).toFixed(1));
            case DistanceUnit.MILE: 
                return parseFloat((distanceM / 1609).toFixed(1));
        }
    }

    public convertDefaultWindSpeed(windSpeed: number): number {
        switch (this.windSpeedCode) {
            case WindSpeedUnit.MPH: 
                return parseFloat((windSpeed / 2.237).toFixed(1));
            case WindSpeedUnit.KMH: 
                return parseFloat((windSpeed / 3.6).toFixed(1));
            case WindSpeedUnit.KNOTS: 
                return parseFloat((windSpeed / 1.944).toFixed(1));
            case WindSpeedUnit.MPS: 
                return windSpeed;
            case WindSpeedUnit.BFT: 
                return parseFloat((windSpeed / 1.126).toFixed(1));
        }
    }

    public convertDefaultTemperature(temperature: number): number {
        switch (this.temperatureCode) {
            case TemperatureUnit.C: 
                return temperature;
            case TemperatureUnit.F: 
                return parseFloat(((temperature - 32) * 5 / 9).toFixed(1));
        }
    }

    public convertDefaultDistance(distance: number): number {
        switch (this.distanceCode) {
            case DistanceUnit.KM: 
                return parseInt((distance * 1000).toFixed(1));
            case DistanceUnit.MILE: 
                return parseInt((distance * 1609).toFixed(1));
        }
    }
}